<div class="item item-content" [class]="{ disabled: model.disabled, selected: selected }">
  <entity-icon
    data-cy="suggestion-dropdown-icon"
    *ngIf="model.icon"
    [class.stick-top]="!!model.subtitle"
    class="item-icon"
    [model]="model.icon"
    [size]="'16px'"
  ></entity-icon>
  <u-emoji *ngIf="model?.emojiUnicode" [spriteEmojiSize]="18" [unicode]="model.emojiUnicode"></u-emoji>

  <div data-cy="suggestion-title-container" class="item-title-container" #titleContainer>
    <h3
      data-cy="suggestion-dropdown-title"
      class="item-title"
      #itemTitle
      tooltipPosition="bottom"
      [pTooltip]="displayTooltip ? (model.data?.value || model.title) : null"
      tooltipStyleClass="u-tooltip"
    >
      {{ model.title }}
    </h3>
    <h4 data-cy="suggestion-dropdown-subtitle" class="item-subtitle" *ngIf="model.subtitle">{{ model.subtitle }}</h4>
  </div>

  <span data-cy="suggestion-dropdown-label" class="item-label" *ngIf="model.data?.showLabelOnTag">{{ model.label }}</span>
</div>
